import { render, staticRenderFns } from "./ContributionsActivity.vue?vue&type=template&id=3901e164&scoped=true"
import script from "./ContributionsActivity.vue?vue&type=script&lang=ts"
export * from "./ContributionsActivity.vue?vue&type=script&lang=ts"
import style0 from "./ContributionsActivity.vue?vue&type=style&index=0&id=3901e164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3901e164",
  null
  
)

export default component.exports